import { LegalPage } from '../components/LegalPage';

const TermsOfServicePage = () => <LegalPage doc="terms" testId="terms-of-service-page" />;

export default TermsOfServicePage;
